"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";

export function SearchPageHero({
  image = "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657253169f6915619c8b668e_Rectangle-86.png",
  showSearchHero = false,
}) {
  return showSearchHero ? (
    <Block className={"search-page-hero-container"} tag={"header"}>
      <Block className={"padding-global-v2"} tag={"div"}>
        <Block className={"container-small"} tag={"div"}>
          <Block className={"padding-section-medium"} tag={"div"}>
            <Block className={"text-align-left"} tag={"div"}>
              <Heading className={"text-color-white small-h1"} tag={"h1"}>
                {"Our Communities"}
              </Heading>
            </Block>
          </Block>
        </Block>
      </Block>
      <Block className={"header69_background-image-wrapper"} tag={"div"}>
        <Block className={"image-overlay-layer"} tag={"div"} />
        <Image
          alt={""}
          className={"header69_background-image-copy"}
          // @ts-ignore - User-defined custom attribute(s)
          fetchPriority={"high"}
          height={"auto"}
          loading={"eager"}
          src={image}
          width={"auto"}
        />
      </Block>
    </Block>
  ) : null;
}
